import { useState } from "react";
import { FaLinkedin } from "react-icons/fa";
import { CiLocationOn } from "react-icons/ci";
import { IoMailUnreadOutline } from "react-icons/io5";
import { MdPhoneAndroid } from "react-icons/md";
import { PiBuildingApartment } from "react-icons/pi";
import { RiLink } from "react-icons/ri";
import { LuFactory } from "react-icons/lu";
import { LuUsers } from "react-icons/lu";
import CircleIcon from "../../../Assets/images/icons/circle-icon.png"
import orgData from './orgdata.json';
import { Row } from "react-bootstrap";
import Pagination from "../../../Components/formModules/Pagination";
import { RiFacebookFill } from "react-icons/ri";
import { FaSquareXTwitter } from "react-icons/fa6";
import { MdArrowOutward } from "react-icons/md";
import { IoCallOutline } from "react-icons/io5";

const ContactTableData = ({
    selectedOption
}) => {
    let [currentPage, setCurrentPage] = useState(1);
    let [pageSize, setPageSize] = useState(5);

    const formatMobileNumber = (number) => {
        if (!number) return '';
        const updated_no = number.replace(/\D/g, '');
        if (updated_no.length !== 10) return number;
        return `+91${updated_no.slice(0, 3)} ${updated_no.slice(3, 6)} ${updated_no.slice(6)}`;
    }

    return (
        <>
            <div className="fw-semibold fs-6 my-2">{selectedOption}</div>
            <Row>
                <div className="col-4 d-flex align-items-center">
                    <div className="btn-group">
                        <button type="button" className="btn btn-primary btn-blue rounded-2"><span>Export</span></button>
                        <button type="button" className="btn btn-outline-primary btn-blue rounded-2"><span>Find Matching Contacts</span></button>
                    </div>
                </div>
                <div className="col-2 d-flex align-items-center">
                    <p className="fw-semibold- text-secondary mb-0">250 Companies Found</p>
                </div>
                {/* <div className="col-6 datavault-pagination">
                    <div className="ag-theme-quartz" style={{ height: "auto", display: "flex", flexDirection: "column", position: "relative" }}>
                        <Pagination
                            className="border-0"
                            currentPage={currentPage}
                            pageSize={pageSize}
                            totalCount={5}
                        // onPageSizeChange={handlePageSizeChange}
                        // onPrevPage={handlePrevPage}
                        // onNextPage={handleNextPage}
                        />
                    </div>
                </div> */}
            </Row>
            <div className="tbl-container rounded-table mt-2">
                <div className="table-responsive">
                    <table className="table table-hover hover-icon-table users-table mb-0">
                        <thead>
                            <tr>
                                <th>
                                    <input className="form-check-input" type="checkbox" />
                                </th>
                                <th></th>
                                <th className="w-50">Name</th>
                                <th className="w-30">Company Details</th>
                                <th className="w-30">Sector</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orgData?.contact_name?.length > 0 ?
                                <>
                                    {orgData?.contact_name?.
                                        map((data, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <input className="form-check-input" type="checkbox" />
                                                </td>
                                                <td>
                                                    <span className="me-2">
                                                        <PiBuildingApartment style={{ color: 'darkgrey', fontSize: '30px', border: '1px solid lightgrey', padding: '2px', borderRadius: '3px' }} />
                                                    </span>
                                                </td>
                                                <td className="w-50">
                                                    <div>
                                                        <span style={{ color: 'rgb(118,101,199)' }}>{data?.client_company}</span> |
                                                        <span className="ms-1 me-1"><RiLink /></span>
                                                        <span className="me-1"><RiFacebookFill style={{ color: 'rgb(62,133,228)' }} /></span>
                                                        <span className="me-1"><FaSquareXTwitter /></span>
                                                        <FaLinkedin style={{ color: 'rgb(0,119,181)' }} /></div>
                                                    <div className="text-secondary">
                                                        <span className="me-2">
                                                            <CiLocationOn />
                                                        </span>{data?.city},
                                                        <span>{data?.state},
                                                        </span>{data?.country}
                                                    </div>
                                                    <div>
                                                        <button className="border-0" style={{ background: 'rgb(232,232,246)', color: 'rgb(96,71,211)', fontSize: '12px', borderRadius: '3px' }}>
                                                            {data?.contacts} Contacts <span style={{ fontSize: '15px' }}><MdArrowOutward /></span>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td className="w-50">
                                                    <div className="text-secondary">
                                                        <span className="me-2">
                                                            <LuFactory className="text-secondary" />
                                                        </span>
                                                        {data?.company_type}
                                                    </div>
                                                    <div className="text-secondary">
                                                        <span className="me-2">
                                                            <LuUsers className="text-secondary" />
                                                        </span>
                                                        {data?.employee_count}
                                                        <span className="ms-2 me-2">
                                                            <img src={CircleIcon} height={12} width={12} />
                                                        </span>
                                                        <span>{data?.value}</span>
                                                    </div>
                                                    <div className="text-secondary">
                                                        <span className="me-2">
                                                            <IoCallOutline className="text-secondary" />
                                                        </span>
                                                        {formatMobileNumber(data?.contact_mobile)}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="text-secondary">
                                                        {data?.company_type}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                </>
                                :
                                <tr>
                                    <td colSpan={3} className='text-center'>No Data Found</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                    <div className="datavault-pagination">
                        <div className="ag-theme-quartz" style={{ height: "auto", display: "flex", flexDirection: "column", position: "relative" }}>
                            <Pagination
                                className="border-0"
                                currentPage={currentPage}
                                pageSize={pageSize}
                                totalCount={5}
                            // onPageSizeChange={handlePageSizeChange}
                            // onPrevPage={handlePrevPage}
                            // onNextPage={handleNextPage}
                            />
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
export default ContactTableData;